import React, { useEffect, useState } from 'react';
import { Alert, Button } from '@intech/web-ui';

import { FaCheck, FaTimes, FaArrowLeft } from 'react-icons/fa';

import config from "./../../../config.json";
import { LGPDService, UsuarioService } from '@services';
import { useHistory } from 'react-router-dom';
import { BaseAuth } from '../Base';
import { LGPDConsentimentoEntidade } from '@entidades';
import { LoadingComponent } from '@components';

export const Termos: React.FC = () => {
  const history = useHistory();

  const [AlertText, setAlertText] = useState<string>("");
  const [Loading, setLoading] = useState<boolean>(true);
  const [Admin, setAdmin] = useState<boolean>(true);
  const [PrecisaAceitar, setPrecisaAceitar] = useState<boolean>(true);
  const [Termos, setTermos] = useState<Array<LGPDConsentimentoEntidade>>(new Array<LGPDConsentimentoEntidade>());

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {

        const TermoPortal = await LGPDService.Buscar(1);
        setPrecisaAceitar(TermoPortal.length === 0);

        const Termos = await LGPDService.BuscarTodos();
        setTermos(Termos);

        const Admin = await UsuarioService.VerificarAdmin();
        setAdmin(Admin);
      }
      catch (e) {
        const error = e.response ? e.response.data : e;
        setAlertText(error);
      }
      setLoading(false);
    })();
  }, []);

  async function Accept() {
    try {
      await LGPDService.Inserir(1);
      history.push('primeiroAcesso');
    }
    catch (e) {
      const error = e.response ? e.response.data : e;
      console.log(error);
    }
  }

  function Refuse() {
    window.alert("Sem o consentimento expresso no termo, o acesso ao portal do Participante não será permitido.");
    localStorage.removeItem(`@${config.appName}:token`);
    localStorage.removeItem(`@${config.appName}:token-admin`);
    history.push('login');
  }

  return (
    <BaseAuth tamanho={550}>

      {Loading && <LoadingComponent />}

      {!Loading && (<>
        <h5 className="mt-5">
          {"TERMO DE CONSENTIMENTO E AUTORIZAÇÃO LIVRE, ESCLARECIDO E INEQUÍVOCO DE UTILIZAÇÃO DE DADOS PESSOAIS"}

          {/*
          Por algum motivo o br só funcionou aqui
          */}
          <br />
          <br />
        </h5>

        <p style={{ textAlign: "justify" }}>
          {"Nos termos do presente termo de consentimento e de acordo com o art. 5o, XII, da Lei 13.709/2018 – LEI GERAL DE PROTEÇÃO DE DADOS, manifesto minha livre e inequívoca autorização, pela qual concordo com a consulta e tratamento dos meus dados pessoais, financeiros e cadastrais e de meus dependentes, constantes nas bases de dados da FAELCE – FUNDAÇÃO COELCE DE SEGURIDADE SOCIAL, para que os utilize e disponibilize nos serviços previstos neste portal, relacionados aos Planos de Benefícios administrados por esta Fundação."}
        </p>

        <Alert type={"danger"}>
          {AlertText}
        </Alert>

        {Termos.length > 0 && (<>
          {Termos.map((Termo: LGPDConsentimentoEntidade, index: number) => {
            return (
              <div className={"alert alert-info"} key={index}>
                {`Aceito em: ${Termo.DTA_CONSENTIMENTO} via ${Termo.TXT_ORIGEM}.`}
                <br />
                {`Código Identificador: ${Termo.COD_IDENTIFICADOR}`}
                {Termo.DIAS_EXPIRACAO && (<>
                  <br />
                  {`Dias até próxima expiração: ${Termo.DIAS_EXPIRACAO}`}
                </>)}
              </div>
            )
          })}
        </>)}

        {PrecisaAceitar && Admin && (<>
          <Alert type={"warning"}>
            {"Esse participante ainda não aceitou os termos LGPD no PORTAL PARTICIPANTE"}
          </Alert>
        </>)}

        {!(PrecisaAceitar && !Admin) && (<>
          <Button
            icon={<FaArrowLeft />}
            onClick={() => history.goBack()}
            type={"light"}
            title={"Voltar"}
            block
          />
        </>)}

        {PrecisaAceitar && !Admin && (<>
          <Button
            icon={<FaCheck />}
            onClick={Accept}
            type="primary"
            title={"Li e concordo com o termo acima"}
            block
          />

          <Button
            icon={<FaTimes />}
            onClick={Refuse}
            type={"light"}
            title={"Agora não"}
            block
          />
        </>)}

      </>)}
    </BaseAuth>
  );
}